module.exports = __webpack_public_path__ + "img/area-part4-122.cf3fff73.png";